// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Option = require("rescript/lib/js/belt_Option.js");
var MM_proof_tree = require("./MM_proof_tree.res.js");
var MM_substitution = require("./MM_substitution.res.js");

function getArgToMatchPriv(frame, args, hypLabelToMatch, hypIdxToMatch) {
  var res;
  var i = 0;
  var eHypI = {
    contents: 0
  };
  var maxI = frame.hyps.length - 1 | 0;
  while(i <= maxI && Belt_Option.isNone(res)) {
    var hyp = frame.hyps[i];
    if (hyp.typ === "E") {
      if (Belt_Option.getWithDefault(Belt_Option.map(hypLabelToMatch, (function(hyp){
                return function (label) {
                  return label === hyp.label;
                }
                }(hyp))), false) || Belt_Option.getWithDefault(Belt_Option.map(hypIdxToMatch, (function (idx) {
                    return idx === eHypI.contents;
                  })), false)) {
        res = MM_proof_tree.pnGetExpr(args[i]);
      } else {
        eHypI.contents = eHypI.contents + 1 | 0;
      }
    }
    i = i + 1 | 0;
  };
  return res;
}

function getArgToMatch(matcher, idx, src) {
  if (typeof src !== "object") {
    return ;
  }
  if (src.TAG !== "Assertion") {
    return ;
  }
  var frame = src.frame;
  var args = src.args;
  var label = matcher.hypMatchers[idx];
  if (label.TAG === "Label") {
    return getArgToMatchPriv(frame, args, label._0, undefined);
  } else {
    return getArgToMatchPriv(frame, args, undefined, label._0);
  }
}

function exprSrcMatchesPriv(expr, src, matcher, idx, parenCnt) {
  if (idx === matcher.frm.numOfHypsE) {
    return true;
  }
  if (idx === -1) {
    var res = {
      contents: false
    };
    var frm = matcher.frm;
    MM_substitution.iterateSubstitutions(frm.frame.asrt, expr, frm.frmConstParts[frm.numOfHypsE], frm.constParts[frm.numOfHypsE], frm.varGroups[frm.numOfHypsE], frm.subs, parenCnt, (function (param) {
            var remainingMatches = exprSrcMatchesPriv(expr, src, matcher, idx + 1 | 0, parenCnt);
            if (remainingMatches) {
              res.contents = true;
              return "Stop";
            } else {
              return "Continue";
            }
          }));
    return res.contents;
  }
  var argToMatch = getArgToMatch(matcher, idx, src);
  if (argToMatch === undefined) {
    return false;
  }
  var res$1 = {
    contents: false
  };
  var frm$1 = matcher.frm;
  MM_substitution.iterateSubstitutions(frm$1.hypsE[idx].expr, argToMatch, frm$1.frmConstParts[idx], frm$1.constParts[idx], frm$1.varGroups[idx], frm$1.subs, parenCnt, (function (param) {
          var remainingMatches = exprSrcMatchesPriv(expr, src, matcher, idx + 1 | 0, parenCnt);
          if (remainingMatches) {
            res$1.contents = true;
            return "Stop";
          } else {
            return "Continue";
          }
        }));
  return res$1.contents;
}

function exprSrcMatches(expr, src, matcher, parenCnt) {
  if (matcher.matchAsrt) {
    return exprSrcMatchesPriv(expr, src, matcher, -1, parenCnt);
  } else {
    return exprSrcMatchesPriv(expr, src, matcher, 0, parenCnt);
  }
}

exports.exprSrcMatches = exprSrcMatches;
/* MM_proof_tree Not a pure module */
